import { forwardRef } from "react";
import { FlatList, Platform, ScrollViewProps, View } from "react-native";
import { flatList, ScrollView } from "./styled";

interface Props extends ScrollViewProps {
  containerClassName?: string;
  contentContainerClassName?: string;
  grow?: boolean;
}

const StyledFlatList = flatList();

const ScrollableContainer = forwardRef<FlatList, Props>(
  ({ children, containerClassName, contentContainerClassName, grow, ...props }, ref) => {
    if (grow) {
      return (
        <ScrollView
          ref={ref}
          {...props}
          className={containerClassName}
          contentContainerStyle={`grow ${contentContainerClassName}`}
          // Web Hack: Allows ActionContainer to display top border across ScreenContainer
          {...(Platform.OS === "web" && { style: { overflow: "visible" } })}
        >
          <View className="max-w-3xl mx-auto w-full grow">{children}</View>
        </ScrollView>
      );
    } else {
      return (
        <StyledFlatList
          ref={ref}
          {...props}
          className={containerClassName}
          contentContainerStyle={contentContainerClassName}
          // Web Hack: Allows ActionContainer to display top border across ScreenContainer
          {...(Platform.OS === "web" && { style: { overflow: "visible" } })}
          data={[{}]}
          renderItem={() => <View className="max-w-3xl mx-auto w-full">{children}</View>}
        />
      );
    }
  }
);

export default ScrollableContainer;
